import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { AboutTeaser } from "../components/site/AboutTeaser";
import { ServicesBento } from "../components/site/ServicesBento";
import { WhyChooseUs } from "../components/site/WhyChooseUs";
import { DivineBlessings } from "../components/site/DivineBlessings";
import { Testimonials } from "../components/site/Testimonials";
import { CTASection } from "../components/site/CTASection";
import { usePageMeta } from "../components/site/SmoothScroll";

const WORDS = ["Vedic Astrology", "Tarot Card Reading", "Psychic Guidance", "Palm Reading", "Spiritual Healing", "Love & Marriage", "Calgary, Alberta"];

export default function Home() {
  usePageMeta(
    "Astrologer in Calgary | Astrology, Psychic & Tarot Readings | Astrologer & Spiritual Healers",
    "Looking for an astrologer in Calgary? Book Vedic astrology, psychic and tarot card readings, palm reading, love guidance and spiritual healing with Astrologer & Spiritual Healers."
  );
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee items={WORDS} testId="home-marquee" />
      <AboutTeaser />
      <ServicesBento />
      <DivineBlessings />
      <WhyChooseUs />
      <Testimonials />
      <CTASection />
    </main>
  );
}
